export default defineNuxtRouteMiddleware((_, __) => {
  useDiaShow().reset();
});
